import { useEffect, useState, useRef } from "react";
import { Truck, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

// const FREE_SHIPPING_THRESHOLD = 599; // Re-enable when shipping threshold is active

function AnnouncementBar({ cartTotal = 0, user }) {
  const [index, setIndex] = useState(0);
  // const [timeLeft, setTimeLeft] = useState(getTimeRemaining()); // Re-enable for countdown
  const [paused, setPaused] = useState(false);
  const touchStartX = useRef(0);
  const navigate = useNavigate();

  // 🕒 Countdown Logic — re-enable when needed
  // function getTimeRemaining() {
  //   const end = new Date();
  //   end.setHours(23, 59, 59);
  //   const diff = end - new Date();
  //   const hours = Math.floor(diff / (1000 * 60 * 60));
  //   const minutes = Math.floor((diff / (1000 * 60)) % 60);
  //   const seconds = Math.floor((diff / 1000) % 60);
  //   return `${hours}h ${minutes}m ${seconds}s`;
  // }

  // useEffect(() => {
  //   const timer = setInterval(() => { setTimeLeft(getTimeRemaining()); }, 1000);
  //   return () => clearInterval(timer);
  // }, []);

  // 🔄 Auto Slide
  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % messages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [paused]);

  // 💡 Messages
  const messages = [
    {
      icon: <Sparkles size={13} className="text-[#D4AF37]" />,
      text: " Welcome Offer • 10% Off Your First Order",
      action: () => navigate("/shop"),
    },
    {
      icon: <Truck size={13} className="text-[#D4AF37]" />,
      text: "Free Shipping on Orders",
      action: () => navigate("/shop"),
    },
    {
      icon: <Sparkles size={13} className="text-[#D4AF37]" />,
      text: "925 Sterling Silver • Hypoallergenic • Tarnish Resistant",
      action: () => navigate("/shop"),
    },
    !user && {
      icon: <Sparkles size={13} className="text-[#D4AF37]" />,
      text: "Login & unlock exclusive offers",
      action: () => navigate("/login"),
    },
  ].filter(Boolean);

  // 👉 Swipe Support
  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 50) setIndex((prev) => (prev + 1) % messages.length);
    else if (diff < -50) setIndex((prev) => prev === 0 ? messages.length - 1 : prev - 1);
  };

  return (
    <div
      className="w-full bg-zinc-900 text-white py-2.5 sticky top-0 z-50 overflow-hidden"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="relative h-6 flex items-center justify-center">
        {messages.map((msg, i) => (
          <button
            key={i}
            onClick={msg.action}
            className={`absolute flex items-center gap-2 text-xs uppercase tracking-widest font-medium transition-all duration-500 ${
              i === index ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            {msg.icon}
            {msg.text}
          </button>
        ))}
      </div>

      {/* Progress bar — re-enable with threshold when FREE_SHIPPING_THRESHOLD is active */}
      {/* <div className="w-full bg-zinc-800 h-1 mt-2">
        <div
          className="bg-[#D4AF37] h-1 transition-all duration-500"
          style={{ width: `${Math.min((cartTotal / FREE_SHIPPING_THRESHOLD) * 100, 100)}%` }}
        />
      </div> */}
    </div>
  );
}

export default AnnouncementBar;
